module.exports = __webpack_public_path__ + "static/media/icon-session.c395d13b.svg";